function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import SandboxRequestDetailComponent from '@/apps/attributes/modules/use_cases/components/SandboxRequestDetailComponent';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import PartitionReviewDialog from '@/apps/attributes/modules/use_cases/components/PartitionReviewDialog';
import { mapState, mapMutations } from 'vuex';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import tasks from '@/js/tasks';
export default {
  name: 'OwnershipRequestPage',
  components: {
    DialogsComponent: DialogsComponent,
    SandboxRequestDetailComponent: SandboxRequestDetailComponent,
    PartitionReviewDialog: PartitionReviewDialog
  },
  mixins: [localPaginationMixin, filterMixin],
  data: function data() {
    var STATUS_ACTIVE = '1';
    var STATUS_INACTIVE = '0';
    return {
      STATUS_ACTIVE: STATUS_ACTIVE,
      STATUS_INACTIVE: STATUS_INACTIVE,
      activeTab: 0,
      DIALOG_SEE_SANDBOX_REQUEST: 'DIALOG_SEE_SANDBOX_REQUEST',
      DIALOG_ADD_BASE_IDS: 'DIALOG_ADD_BASE_IDS',
      items: [],
      createAttrItems: [],
      createAttrLoading: false,
      createAttrLoaded: false,
      createAttrPagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      useCase: {},
      search: '',
      filters: {
        text_filter: ''
      },
      loading: {
        reject: false,
        approve: false
      },
      is_nivel_carga: false,
      value: 0,
      interval: 0,
      texto_finalizar: 'Aprove'
    };
  },
  created: function created() {
    this.getUseCases();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading', 'setValue'])), {}, {
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onOpenModalUseCase: function onOpenModalUseCase(item, modalName) {
      this.useCase = item;
      this.openDialog(modalName);
    },
    onCloseModal: function onCloseModal(modalName) {
      this.$refs[modalName].onClose();
      this.loading.approve = false;
      this.loading.reject = false;
      this.getUseCases();
    },
    getUseCases: function getUseCases() {
      var _this = this;
      this.setShowLoading(true);
      var params = {
        user: window.userInfo.email
      };
      UseCasesService.getUseCasesByStatusId(this.companyCode, '1', params).then(function (response) {
        _this.items = response.data.records;
        _this.setShowLoading(false);
      });
    },
    onSearch: function onSearch() {
      this.search = this.filters.text_filter;
    },
    onCleanSearch: function onCleanSearch() {
      this.search = '';
      this.filters.text_filter = '';
    },
    onChangePercentage: function onChangePercentage(value) {
      this.value = value;
    },
    btnColor: function btnColor() {
      return this.loading.approve ? 'light' : 'primary';
    },
    refreshClick: function refreshClick() {
      if (this.activeTab === 1) {
        this.fetchCreateAttributeRequests();
        return;
      }
      this.getUseCases();
    },
    fetchCreateAttributeRequests: function fetchCreateAttributeRequests() {
      var _this2 = this;
      this.createAttrLoading = true;
      var params = {
        type_export_id: 5,
        estado: 1,
        role: 1,
        sbidv: 1,
        env: 'all',
        page: 1,
        page_size: 200
      };
      UseCasesService.getProductizeHistory({
        params: params
      }).then(function (response) {
        var payload = response && response.data || {};
        _this2.createAttrItems = payload.records || [];
        _this2.createAttrPagination.total = payload.total || _this2.createAttrItems.length;
        _this2.createAttrLoaded = true;
      }).catch(function (err) {
        console.error(err);
        tasks.lockScreen.unlock();
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      }).finally(function () {
        _this2.createAttrLoading = false;
      });
    },
    openPartitionReview: function openPartitionReview(item) {
      this.$refs.partitionReviewDialog.open(item);
    },
    onCreateAttrApproved: function onCreateAttrApproved() {
      this.createAttrPagination.current = 1;
      this.fetchCreateAttributeRequests();
    },
    formatCreateAttrDate: function formatCreateAttrDate(value) {
      if (!value) return '-';
      var match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
      if (!match) return value;
      var _match = _slicedToArray(match, 6),
        year = _match[1],
        month = _match[2],
        day = _match[3],
        hour = _match[4],
        minute = _match[5];
      return hour ? "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minute) : "".concat(day, "/").concat(month, "/").concat(year);
    },
    periodCount: function periodCount(item) {
      var value = item && item.total_periods;
      return value === null || value === undefined || value === '' ? '-' : value;
    }
  }),
  watch: {
    activeTab: function activeTab(value) {
      if (value === 1 && !this.createAttrLoaded) {
        this.fetchCreateAttributeRequests();
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('attribute', ['solicitudeTypes'])), mapState('data-platform', ['companyCode'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('descripcion.ownership_requests'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        text: this.translate('table_sandbox_requests.organization'),
        value: 'organization',
        align: 'start'
      }, {
        text: this.translate('table_sandbox_requests.owner'),
        value: 'owner_name',
        align: 'start'
      }, {
        text: this.translate('table_sandbox_requests.use_case'),
        value: 'business_name',
        align: 'start'
      }, {
        text: this.translate('table_sandbox_requests.date_created'),
        value: 'request_creation_date',
        align: 'center'
      }, {
        text: this.translate('table_sandbox_requests.attributes'),
        value: 'attribute_count',
        align: 'end'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    createAttrHeaders: function createAttrHeaders() {
      return [{
        text: this.$t('ownership_requests.create_attribute.use_case'),
        value: 'caso_de_uso',
        align: 'start'
      }, {
        text: this.$t('ownership_requests.create_attribute.table_name'),
        value: 'nombre_tabla',
        align: 'start'
      }, {
        text: this.$t('ownership_requests.create_attribute.periods'),
        value: 'total_periods',
        align: 'center'
      }, {
        text: this.$t('ownership_requests.create_attribute.date'),
        value: 'fecha_creacion',
        align: 'center'
      }, {
        text: this.$t('ownership_requests.create_attribute.operator'),
        value: 'owner_name',
        align: 'start'
      }, {
        text: '',
        value: 'actions',
        align: 'center',
        sortable: false
      }];
    },
    dialogTitle: function dialogTitle() {
      var solicitudeTypeId = this.useCase.last_solicitude_type_id || 1;
      var dialogTitle = '';
      switch (solicitudeTypeId) {
        case 1:
          dialogTitle = 'Solicitud de creación de Sandbox';
          break;
        case 2:
          dialogTitle = "Solicitud de actualizaci\xF3n de Sandbox: ".concat(this.solicitudeTypes['2']);
          break;
        case 3:
          dialogTitle = "Solicitud de actualizaci\xF3n de Sandbox: ".concat(this.solicitudeTypes['3']);
          break;
        case 4:
          dialogTitle = "Solicitud de actualizaci\xF3n de Sandbox: ".concat(this.solicitudeTypes['4']);
          break;
      }
      return dialogTitle;
    },
    totalRecords: function totalRecords() {
      if (this.items.length === 0) {
        return 0;
      } else {
        return this.pagination.total;
      }
    }
  })
};